import { SkeletonText } from '@carbon/react';
import style from './evaluation-tile.module.scss';

/**
 * Skeleton placeholder that matches the EvaluationTile layout.
 * Renders while calculations are loading for a workspace.
 *
 * @return {JSX.Element} The skeleton tile.
 */
export const EvaluationTileSkeleton = (): JSX.Element => {
  return (
    <div className={style.tile}>
      <div className={style.header}>
        <SkeletonText width="40%" />
      </div>
      <div className={style.field}>
        <SkeletonText width="80%" />
      </div>
      <div className={style.field}>
        <SkeletonText width="60%" />
      </div>
      <div className={style.field}>
        <SkeletonText width="50%" />
      </div>
      <div className={style.field}>
        <SkeletonText width="45%" />
      </div>
    </div>
  );
};
